import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cc7340e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"margin-top":"8px","display":"flex","flex-direction":"column"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "show-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"display":"none"} }

import { computed, ref } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { UploadChangeParam, UploadProps } from 'ant-design-vue';
import config from '@/config';
import { tokenManager } from '@/util/token';
import { ImgFieldType } from '@/components/business/crud/interface/FieldType';


import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { edit: 'normal', show: 'normal' },
});

export default /*#__PURE__*/_defineComponent({
  __name: 'ImgForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const uploadPath = config.uploadApiPath;
const uploadList = ref<Exclude<UploadProps['fileList'], undefined>>([]);
const headers = {
  ...tokenManager.get(),
};

function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');

const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = '';
};
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string;
  }
  previewImage.value = file.url || file.preview;
  previewVisible.value = true;
  previewTitle.value =
    file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};

const fileList = computed(() => {
  let res: Exclude<UploadProps['fileList'], undefined> = [];
  if (data.value[props.propName]) {
    if (typeof data.value[props.propName] === 'string') {
      res.push({
        uid: data.value[props.propName],
        name: data.value[props.propName],
        status: 'done',
        url: config.uploadPath + data.value[props.propName],
      });
    } else {
      res = data.value[props.propName].map((item: string) => {
        return {
          uid: item,
          name: item,
          status: 'done',
          url: config.uploadPath + item,
        };
      });
    }
  }
  return res.concat(...uploadList.value);
});

function onChange(info: UploadChangeParam) {
  uploadList.value = info.fileList.filter((file) => file.status !== 'done');
  const file = info.file;
  if (file.status === 'removed') {
    if (props.widget.multi) {
      if (data.value[props.propName]) {
        if (!(data.value[props.propName] instanceof Array)) {
          data.value[props.propName] = [data.value[props.propName]];
        }
        data.value[props.propName] = data.value[props.propName].filter(
          (id: string) => id !== file.uid
        );
      }
    } else {
      data.value[props.propName] = null;
    }
  } else if (file.status === 'done') {
    if (props.widget.multi) {
      if (!data.value[props.propName]) {
        data.value[props.propName] = [];
      }
      if (!(data.value[props.propName] instanceof Array)) {
        data.value[props.propName] = [data.value[props.propName]];
      }
      data.value[props.propName].push(file.response.data.path);
    } else {
      data.value[props.propName] = file.response.data.path;
    }
  }
}

const images = computed(() => {
  const images = data.value[props.propName];
  if (images instanceof Array) {
    return images
      .filter((i) => i)
      .map((i) => (i.startsWith('/') ? config.uploadPath + i : i));
  }
  if (typeof images === 'string') {
    return [images.startsWith('/') ? config.uploadPath + images : images];
  }
  return [];
});

const visible = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!

  return (_ctx.info.status === 'edit')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_a_upload, {
          action: _unref(uploadPath),
          "file-list": fileList.value,
          headers: headers,
          accept: "image/*",
          "list-type": "picture-card",
          onChange: onChange,
          onPreview: handlePreview,
          multiple: _ctx.widget.multi
        }, {
          default: _withCtx(() => [
            (_ctx.info.status === 'edit')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 上传 "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["action", "file-list", "multiple"]),
        _createVNode(_component_a_modal, {
          footer: null,
          title: previewTitle.value,
          visible: previewVisible.value,
          onCancel: handleCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: previewImage.value,
              alt: "example",
              style: {"width":"100%"}
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["title", "visible"])
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
            return (_openBlock(), _createElementBlock("img", {
              class: "img",
              src: image,
              key: index,
              onClick: _cache[0] || (_cache[0] = () => (visible.value = !visible.value))
            }, null, 8, _hoisted_5))
          }), 128)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_image_preview_group, {
              preview: { visible: visible.value, onVisibleChange: (vis) => (visible.value = vis) }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                  return (_openBlock(), _createBlock(_component_a_image, {
                    width: 50,
                    src: image,
                    key: index
                  }, null, 8, ["src"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["preview"])
          ])
        ])
      ]))
}
}

})